/**
 * Utility để quản lý việc mở lại modal sau khi thực hiện action
 * Cho phép các trang khác nhau đăng ký callback để mở lại modal
 */

type ReopenCallback = () => void;

class ModalReopenManager {
  private reopenCallbacks: Map<string, ReopenCallback> = new Map();

  /**
   * Đăng ký callback để mở lại modal
   * @param modalId - ID duy nhất của modal (ví dụ: 'create-incoming-document')
   * @param callback - Callback để mở lại modal
   */
  register(modalId: string, callback: ReopenCallback): void {
    this.reopenCallbacks.set(modalId, callback);
  }

  /**
   * Hủy đăng ký callback
   * @param modalId - ID của modal
   */
  unregister(modalId: string): void {
    this.reopenCallbacks.delete(modalId);
  }

  /**
   * Gọi callback để mở lại modal
   * @param modalId - ID của modal
   */
  reopen(modalId: string): void {
    const callback = this.reopenCallbacks.get(modalId);
    if (callback) {
      callback();
    }
  }

  /**
   * Kiểm tra xem có callback được đăng ký không
   * @param modalId - ID của modal
   */
  hasCallback(modalId: string): boolean {
    return this.reopenCallbacks.has(modalId);
  }
}

// Export singleton instance
export const modalReopenManager = new ModalReopenManager();

// Export type
export type { ReopenCallback };

